import * as React from 'react';
export const kaspiSvg = React.forwardRef(function kaspiSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#F14635',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M15.213 17.127c-.8.681-.786 2.58-.769 4.782l.003.624.002.24c.01 2.081.039 3.862.53 4.66.163.265.47.459.877.575.105.003.21.008.318.008 1.01 0 1.99-.124 2.928-.357.39-.186.67-.41.766-.644.057-.152.09-.43.09-.79 0-1.44-.428-4.2-.633-5.53l-.103-.697-.02-.138-.03-.201c-.174-1.184-.463-2.455-2.611-2.787-.598-.094-1.038-.007-1.348.255Zm-3.807 8.928c.07.557.184.98.333 1.25.221.09.447.173.677.249.201-.178.328-.676.287-1.886-.061-1.737-.36-4.027-.825-4.001-.502.03-.693 2.643-.473 4.388Zm10.207-4.297c-.563.28-.344 3.48.235 4.499.06.102.184.119.324.096a11.21 11.21 0 0 0 1.254-.877 1.48 1.48 0 0 0 .12-.386c.109-.553-1.202-3.685-1.933-3.332ZM4 15.898c0 3.985 1.98 7.51 5.018 9.67.08-.094.14-.34.192-.545l.015-.082.065-.291c.247-1.156.295-2.289.158-3.63a9.763 9.763 0 0 0-.344-1.834c-.127-.49-.235-.913-.226-1.57.008-.593.13-1.004.264-1.44.153-.498.325-1.06.35-2.037.065-1.894.262-2.365.83-2.915.566-.547.74-.775.74-1.178 0-.4-.535-1.318.405-2.284.606-.616 1.195-.841 1.618-.841.239 0 .426.071.535.184.302.315.217.925-.386 1.733-.603.812-.584 1.165-.549 1.351.038.19.222.442.575.716.27.219.583.466.784.824.382.678.602 1.325.907 2.22l.085.254.039.099c.297.708 1.016.959 2.256.959 1.288 0 2.654-.837 2.654-1.482 0-.64-.266-.719-.266-1.269 0-.55.826-2.136 2.072-2.136.635 0 .965.458.658 1.092-.3.628-.91 1.523-.91 1.918 0 .732 1.095.166 1.781-.395.7-.562.852-.719 1.333-1.559.291-.519.708-.618.984-.482.307.152.5.603.223 1.248-.217.5-.807 1.136-1.429 1.81-.833.897-1.774 1.916-1.774 2.57 0 3.33 1.886 6.236 2.104 6.555.213.316.329.422.392.453A11.784 11.784 0 0 0 28 15.949v-.104l-.003-.222C27.85 9.18 22.537 4 16 4 9.372 4 4 9.327 4 15.898Z',
      fill: '#fff',
    }),
  );
});
kaspiSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var kaspi = {
  category: 'brand',
  colorable: false,
  name: 'kaspi',
  svg: kaspiSvg,
};
